export default __webpack_public_path__ + "static/media/PEE.4e6dc4d9.png";